import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IFilterTimeline, TimelineService } from '@app/shared/services/timeline/timeline.service';
import Utils from '@app/shared/utils/utils';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({
  template: '',
})
export abstract class TimelineReportComponent implements OnInit {
  model!: string;

  constructor(
    private timelineService: TimelineService,
    private toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.model =
      this.router.url.search('ips') === -1
        ? 'COLLECT_TVF'
        : this.router.url.search('tvo') === -1
        ? 'COLLECT'
        : 'COLLECT_TVO';
  }

  exportFile(data: IFilterTimeline) {
    const dateFormat = 'YYYY-MM-DD';

    const updatedData: IFilterTimeline = {
      idTrade: data.idTrade || '',
      startDate: data.startDate || '',
      endDate: data.endDate || '',
    };

    if (updatedData.startDate) {
      updatedData.startDate = moment(updatedData.startDate).format(dateFormat).toString();
    }

    if (updatedData.endDate) {
      updatedData.endDate = moment(updatedData.endDate).format(dateFormat).toString();
    }

    this.timelineService.timelineReport(updatedData, this.model).subscribe({
      next: async (response: any) => {
        if (response.byteLength === 0) {
          this.toastr.warning('Nenhum relatório encontrado para o filtro atual.');
        } else {
          Utils.createAndDownloadBlobFile(response, 'Relatorio-Linha-Do-Tempo', 'xlsx');
        }
      },
      error: (err) => {
        const { errors } = Utils.arrayBufferToJson(err);
        this.toastr.error(
          errors || 'Ocorreu um erro ao exportar relatório, tente novamente mais tarde.'
        );
      },
    });
  }
}
